module.exports = __webpack_public_path__ + "images/home/index/values-timeline-header-a74eaee8a6cf8818b416e58a3b9082ac.png";